/* @flow */
import * as React from 'react';
import { Switch } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { computed, reaction } from 'mobx';
import type { RouterStore } from 'mobx-react-router';
import { ReactAccessProvider } from 'react-access';

import { renderMainRoutes, getRoutes } from 'routes';
import ContentSection from 'views/PageSections/ContentSection/ContentSection';
import UserStore from 'stores/UserStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import { getI18nInstance } from 'i18nInstance';

type InjectedProps = {
  userStore: UserStore,
  routing: RouterStore,
};

@inject('routing', 'userStore')
@observer
export default class Routing extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  _autorunDisposers: Function[] = [];

  @computed get langParam() {
    const { routing: location } = this.props;

    if (location && location.location) {
      const params = new URLSearchParams(location.location.search);
      return params.get('region');
    }

    return null;
  }

  constructor(props: *) {
    super(props);

    this._autorunDisposers.push(
      reaction(
        () => this.langParam,
        async () => {
          const { userStore } = this.props;

          const i18nInstance = await getI18nInstance();
          const [matchedLanguage] =
            this.langParam === null
              ? []
              : i18nInstance.services.languageUtils.toResolveHierarchy(this.langParam);

          if (userStore.forwardedLanguage !== matchedLanguage) {
            userStore.forwardedLanguage = matchedLanguage;
          }
        },
        { fireImmediately: true }
      )
    );
  }

  render() {
    const { userStore, routing } = this.props;

    return (
      <ReactAccessProvider permissions={[userStore.userRoleId]}>
        <ContentSection>
          <Switch location={routing.location}>
            {renderMainRoutes(
              [
                userStore.getActiveUserFromLocal().is_enabled,
                userStore.getActiveUserFromLocal().onboarding_status,
              ],
              userStore
            )}
          </Switch>
        </ContentSection>
      </ReactAccessProvider>
    );
  }
}
